import { clientSecret as developClientSecret } from './environment.develop'
import type { Apps, Environment } from '@awork/environments/types'

export const environment: Environment = 'runner',
  apiEndpoint = 'https://api.cwork.io/api/v1',
  apiEndpointV2 = 'https://api.cwork.io/api/v2',
  apiHostname = 'cwork.io',
  apiProtocol = 'https://',
  assetsUrl = '/assets/',
  clientSecret = developClientSecret,
  mobileAppClientCredentials = '>>APP_CLIENT_CREDENTIALS',
  releaseName = 'Runner',
  buildName = 'Mobile web',
  version = '0.0.0',
  buildNumber = '0',
  app: Apps = 'mobile',
  pushNotificationSenderId = '561151912625',
  microsoftClientId = 'e97af600-30ec-417f-aca5-04adbf3d6c6f',
  isLiveMobile = false
